import type { SubmitPayload } from "../types";

export interface SubmitFlowDeps {
  /** Отправка выбора на бэкенд (см. utils/api.ts submit). */
  submit: (payload: SubmitPayload) => Promise<void>;
  /** Закрытие мини-приложения (см. utils/platform.ts closeWebApp) — обязано быть устойчивым. */
  close: () => void;
  /** Диагностика ошибки отправки. Окно всё равно закроется — это только лог/UI-реакция. */
  onError?: (error: unknown) => void;
}

/**
 * Оркестрация «выбор варианта в TWA»: шлём submit и ГАРАНТИРОВАННО закрываем окно —
 * при любом исходе.
 *
 * close() стоит в finally, а не только на успехе, намеренно:
 *  - TWA — одноразовый экран выбора, после клика по карточке его роль исчерпана;
 *  - генерация уходит на бэкенд fire-and-forget, окно ждать нечего;
 *  - при обрыве сети НЕЛЬЗЯ отличить «запрос не дошёл» от «дошёл, генерация пошла, но
 *    ответ потерялся» — во втором случае бот уже отвечает, и экран ошибки в TWA прямо
 *    вводит в заблуждение. Меньшее зло — закрыться; если запрос реально не дошёл, бот
 *    промолчит и юзер повторит выбор (фото всё ещё в боте).
 *
 * Ошибка submit НЕ пробрасывается наружу: вызвавший await не должен ловить reject —
 * реакция на ошибку целиком в onError, а гарантия закрытия — в finally.
 */
export async function runSubmit(payload: SubmitPayload, deps: SubmitFlowDeps): Promise<void> {
  try {
    await deps.submit(payload);
  } catch (error) {
    deps.onError?.(error);
  } finally {
    deps.close();
  }
}
